import classNames from 'classnames';
import { markdownToRawMarkup } from '../../utils/html-utils';
import ThemeContainer from '../theme-container/ThemeContainer';
import styles from './standard-banner.module.less';
import VisibleIf from '../VisibleIf';
import Image from '../image/Image';
import { getBlockComponentForContent } from '../../utils/cms-utils';

const StandardBanner = ({ content, text, illustrationUrl, illustrationDescription, link }) => {
    const textAsHtml = markdownToRawMarkup(text);

    const hasImage = !!illustrationUrl;

    return (
        <ThemeContainer className={styles.wrapper}>
            <div className={classNames(styles.bannerContainer, !hasImage && styles.bannerContainerNoImage)}>
                <div className={styles.textBlock}>
                    {text && <div className={styles.text} dangerouslySetInnerHTML={textAsHtml} />}
                    {content?.map((data) => ({
                        ...getBlockComponentForContent({ data }),
                        key: data?.sys?.id,
                    }))}
                    <div className={styles.buttons}>{link && <div className={styles.linkButton}>{link}</div>}</div>
                </div>
                <VisibleIf isVisible={hasImage}>
                    <div className={styles.imageContainer}>
                        <Image src={illustrationUrl} alt={illustrationDescription} role="presentation" />
                    </div>
                </VisibleIf>
            </div>
        </ThemeContainer>
    );
};

export default StandardBanner;
